import { render, staticRenderFns } from "./Localizacao.vue?vue&type=template&id=90adcd0a"
import script from "./Localizacao.vue?vue&type=script&lang=js"
export * from "./Localizacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports